// import ScrollReveal from "scrollreveal";
// const sr = ScrollReveal();

// export default sr;

let sr = null;

export const getSr = async () => {
  if (!sr) {
    const ScrollReveal = (await import("scrollreveal")).default;
    sr = ScrollReveal({ reset: false });
  }
  return sr;
};
